var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "docs-area" }, [
    _c("h1", [_vm._v("\n    " + _vm._s(_vm.$t("docs.header")) + "\n  ")]),
    _vm._v(" "),
    _c("div", { staticClass: "menu-area" }, [
      _c("div", { staticClass: "first-row" }, [
        _c("div", { staticClass: "quater" }, [
          _c("div", { staticClass: "col" }, [
            _c(
              "div",
              {
                class: {
                  "item h-100": true,
                  active: _vm.currentPage === "intro",
                },
                on: {
                  click: function ($event) {
                    return _vm.goToPage("intro")
                  },
                },
              },
              [
                _c(
                  "picture",
                  [
                    _c("source", {
                      attrs: {
                        srcset: "/img/new/notepad.webp",
                        type: "image/webp",
                      },
                    }),
                    _vm._v(" "),
                    _c("nuxt-img", {
                      attrs: {
                        fit: "inside",
                        width: "622",
                        sizes: "sm:300px md:350px lg:500px xl:450px xxl:500px",
                        src: "/img/new/notepad.png",
                        alt: _vm.$t("docs.intro") + " Defi Pool Finance",
                        title: _vm.$t("docs.intro"),
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "h3" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.$t("docs.intro")) +
                      "\n            "
                  ),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "desc" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.$t("docs.intro_desc")) +
                      "\n            "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "chevron-area" },
                  [_c("ChevronDown")],
                  1
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col" }, [
            _c(
              "div",
              {
                class: { item: true, active: _vm.currentPage === "starter" },
                on: {
                  click: function ($event) {
                    return _vm.goToPage("starter")
                  },
                },
              },
              [
                _c(
                  "picture",
                  [
                    _c("source", {
                      attrs: {
                        srcset: "/img/new/floaties.webp",
                        type: "image/webp",
                      },
                    }),
                    _vm._v(" "),
                    _c("nuxt-img", {
                      attrs: {
                        fit: "inside",
                        width: "500",
                        sizes: "sm:300px md:350px lg:500px xl:450px xxl:500px",
                        src: "/img/new/floaties.png",
                        alt: _vm.$t("docs.starter_pack") + " Defi Pool Finance",
                        title: _vm.$t("docs.starter_pack"),
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "h3" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.$t("docs.starter_pack")) +
                      "\n            "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "chevron-area" },
                  [_c("ChevronDown")],
                  1
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                class: { item: true, active: _vm.currentPage === "security" },
                on: {
                  click: function ($event) {
                    return _vm.goToPage("security")
                  },
                },
              },
              [
                _c(
                  "picture",
                  [
                    _c("source", {
                      attrs: {
                        srcset: "/img/new/security.webp",
                        type: "image/webp",
                      },
                    }),
                    _vm._v(" "),
                    _c("nuxt-img", {
                      attrs: {
                        fit: "inside",
                        width: "500",
                        sizes: "sm:300px md:350px lg:500px xl:450px xxl:500px",
                        src: "/img/new/security.png",
                        alt:
                          _vm.$t("docs.security_audits") + " Defi Pool Finance",
                        title: _vm.$t("docs.security_audits"),
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "h3" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.$t("docs.security_audits")) +
                      "\n            "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "chevron-area" },
                  [_c("ChevronDown")],
                  1
                ),
              ]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "quater" }, [
          _c("div", { staticClass: "col" }, [
            _c(
              "div",
              {
                class: { item: true, active: _vm.currentPage === "features" },
                on: {
                  click: function ($event) {
                    return _vm.goToPage("features")
                  },
                },
              },
              [
                _c(
                  "picture",
                  [
                    _c("source", {
                      attrs: {
                        srcset: "/img/new/docs.webp",
                        type: "image/webp",
                      },
                    }),
                    _vm._v(" "),
                    _c("nuxt-img", {
                      attrs: {
                        fit: "inside",
                        width: "554",
                        sizes: "sm:300px md:350px lg:500px xl:450px xxl:500px",
                        src: "/img/new/docs.png",
                        alt: _vm.$t("docs.features") + " Defi Pool Finance",
                        title: _vm.$t("docs.features"),
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "h3" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.$t("docs.features")) +
                      "\n            "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "chevron-area" },
                  [_c("ChevronDown")],
                  1
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                class: { item: true, active: _vm.currentPage === "contracts" },
                on: {
                  click: function ($event) {
                    return _vm.goToPage("contracts")
                  },
                },
              },
              [
                _c(
                  "picture",
                  [
                    _c("source", {
                      attrs: {
                        srcset: "/img/new/contracts.webp",
                        type: "image/webp",
                      },
                    }),
                    _vm._v(" "),
                    _c("nuxt-img", {
                      attrs: {
                        fit: "inside",
                        width: "681",
                        sizes: "sm:300px md:350px lg:500px xl:450px xxl:500px",
                        src: "/img/new/contracts.png",
                        alt:
                          _vm.$t("docs.smart_contracts") + " Defi Pool Finance",
                        title: _vm.$t("docs.smart_contracts"),
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "h3" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.$t("docs.smart_contracts")) +
                      "\n            "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "chevron-area" },
                  [_c("ChevronDown")],
                  1
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col" }, [
            _c(
              "div",
              {
                class: {
                  "item h-100": true,
                  active: _vm.currentPage === "tokenomics",
                },
                on: {
                  click: function ($event) {
                    return _vm.goToPage("tokenomics")
                  },
                },
              },
              [
                _c(
                  "picture",
                  [
                    _c("source", {
                      attrs: {
                        srcset: "/img/new/floatie-token.webp",
                        type: "image/webp",
                      },
                    }),
                    _vm._v(" "),
                    _c("nuxt-img", {
                      attrs: {
                        fit: "inside",
                        width: "490",
                        sizes: "sm:300px md:350px lg:500px xl:450px xxl:490px",
                        src: "/img/new/floatie-token.png",
                        alt: _vm.$t("docs.tokenomics") + " Defi Pool Finance",
                        title: _vm.$t("docs.tokenomics"),
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "h3" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.$t("docs.tokenomics")) +
                      "\n            "
                  ),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "desc" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.$t("docs.tokenomics_desc")) +
                      "\n            "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "chevron-area" },
                  [_c("ChevronDown")],
                  1
                ),
              ]
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "second-row" }, [
        _c("div", { staticClass: "quater" }, [
          _c("div", { staticClass: "col" }, [
            _c(
              "div",
              {
                class: {
                  "item flex-row": true,
                  active: _vm.currentPage === "roadmap",
                },
                on: {
                  click: function ($event) {
                    return _vm.goToPage("roadmap")
                  },
                },
              },
              [
                _c("div", { staticClass: "text-area" }, [
                  _c("div", { staticClass: "h3" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("docs.roadmap")) +
                        "\n              "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "desc" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("docs.roadmap_desc")) +
                        "\n              "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "picture",
                  [
                    _c("source", {
                      attrs: {
                        srcset: "/img/new/roadmap.webp",
                        type: "image/webp",
                      },
                    }),
                    _vm._v(" "),
                    _c("nuxt-img", {
                      attrs: {
                        fit: "inside",
                        width: "575",
                        sizes: "sm:300px md:350px lg:500px xl:450px xxl:490px",
                        src: "/img/new/roadmap.png",
                        alt: _vm.$t("docs.roadmap") + " Defi Pool Finance",
                        title: _vm.$t("docs.roadmap"),
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "chevron-area" },
                  [_c("ChevronDown")],
                  1
                ),
              ]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "quater" }, [
          _c("div", { staticClass: "col" }, [
            _c(
              "div",
              {
                class: { item: true, active: _vm.currentPage === "oracles" },
                on: {
                  click: function ($event) {
                    return _vm.goToPage("oracles")
                  },
                },
              },
              [
                _c(
                  "picture",
                  [
                    _c("source", {
                      attrs: {
                        srcset: "/img/new/oracle.webp",
                        type: "image/webp",
                      },
                    }),
                    _vm._v(" "),
                    _c("nuxt-img", {
                      attrs: {
                        fit: "inside",
                        width: "524",
                        sizes: "sm:300px md:350px lg:500px xl:450px xxl:500px",
                        src: "/img/new/oracle.png",
                        alt: _vm.$t("docs.oracles") + " Defi Pool Finance",
                        title: _vm.$t("docs.oracles"),
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "h3" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.$t("docs.oracles")) +
                      "\n            "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "chevron-area" },
                  [_c("ChevronDown")],
                  1
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col" }, [
            _c(
              "div",
              {
                class: {
                  "item h-50 disabled": true,
                  active: _vm.currentPage === "press_kit",
                },
              },
              [
                _c("div", { staticClass: "h3" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.$t("docs.press_kit")) +
                      "\n            "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "chevron-area" },
                  [_c("ChevronDown")],
                  1
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                class: {
                  "item h-50 disabled": true,
                  active: _vm.currentPage === "links",
                },
              },
              [
                _c("div", { staticClass: "h3" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.$t("docs.links")) +
                      "\n            "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "chevron-area" },
                  [_c("ChevronDown")],
                  1
                ),
              ]
            ),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { ref: "contentArea", staticClass: "content-area" }, [
      _c(
        "div",
        {
          ref: "intro",
          class: { content: true, active: _vm.currentPage === "intro" },
        },
        [
          _c("div", { staticClass: "h2" }, [
            _vm._v("\n        " + _vm._s(_vm.$t("docs.intro")) + "\n      "),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "desc" }, [
            _vm._v(
              "\n        " + _vm._s(_vm.$t("docs.intro_long_desc")) + "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "icon-row" }, [
            _c("div", { staticClass: "icon-area" }, [
              _c("div", { staticClass: "icon" }, [_c("SwapArrows")], 1),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "text-area" }, [
              _c("div", { staticClass: "h4" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("docs.swap")) +
                    "\n          "
                ),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "desc" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("docs.swap_desc")) +
                    "\n          "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "boxes" }, [
                _c("div", { staticClass: "box" }, [
                  _c("div", { staticClass: "h5" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("docs.likeable")) +
                        "\n              "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "desc" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("docs.likeable_desc")) +
                        "\n              "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "icon-bg" }, [_c("Likeable")], 1),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "box" }, [
                  _c("div", { staticClass: "h5" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("docs.low_fees")) +
                        "\n              "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "desc" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("docs.low_fees_desc")) +
                        "\n              "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "icon-bg" }, [_c("LowFee")], 1),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "box" }, [
                  _c("div", { staticClass: "h5" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("docs.decentralized")) +
                        "\n              "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "desc" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("docs.decentralized_desc")) +
                        "\n              "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "icon-bg" },
                    [_c("Decentralize")],
                    1
                  ),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c("div", { staticClass: "icon-row" }, [
            _c("div", { staticClass: "icon-area" }, [
              _c("div", { staticClass: "icon" }, [_c("Figures")], 1),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "text-area" }, [
              _c("div", { staticClass: "h4" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("docs.liquidity")) +
                    "\n          "
                ),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "desc" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("docs.liquidity_desc")) +
                    "\n          "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "boxes" }, [
                _c("div", { staticClass: "box" }, [
                  _c("div", { staticClass: "h5" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("docs.splashie_pools")) +
                        "\n              "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "desc" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("docs.splashie_pools_desc")) +
                        "\n              "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "icon-bg" }, [_c("CryptoCoin")], 1),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "semi-box" }, [
                  _c("div", { staticClass: "box" }, [
                    _c("div", { staticClass: "h5" }, [
                      _vm._v(
                        "\n                  " +
                          _vm._s(_vm.$t("docs.farms")) +
                          "\n                "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "desc" }, [
                      _vm._v(
                        "\n                  " +
                          _vm._s(_vm.$t("docs.farms_desc")) +
                          "\n                "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "icon-bg" }, [_c("Flamingo")], 1),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "box" }, [
                    _c("div", { staticClass: "h5" }, [
                      _vm._v(
                        "\n                  " +
                          _vm._s(_vm.$t("docs.fees")) +
                          "\n                "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "desc" }, [
                      _vm._v(
                        "\n                  " +
                          _vm._s(_vm.$t("docs.fees_desc")) +
                          "\n                "
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "icon-bg" },
                      [_c("ComputerAnalytics")],
                      1
                    ),
                  ]),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c("div", { staticClass: "icon-row" }, [
            _c("div", { staticClass: "icon-area" }, [
              _c("div", { staticClass: "icon" }, [_c("PoolLadder")], 1),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "text-area" }, [
              _c("div", { staticClass: "h4" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("docs.safe")) +
                    "\n          "
                ),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "desc" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("docs.safe_desc")) +
                    "\n          "
                ),
              ]),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "starter",
          class: { content: true, active: _vm.currentPage === "starter" },
        },
        [
          _c("div", { staticClass: "h2" }, [
            _vm._v(
              "\n        " + _vm._s(_vm.$t("docs.starter_pack")) + "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "desc" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("docs.starter_pack_long_desc")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "desc" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("docs.starter_pack_long_desc2")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "wallet-area" }, [
            _c(
              "picture",
              [
                _c("source", {
                  attrs: {
                    srcset: "/img/new/connect_wallet.webp",
                    type: "image/webp",
                  },
                }),
                _vm._v(" "),
                _c("nuxt-img", {
                  attrs: {
                    fit: "inside",
                    width: "2188",
                    sizes: "sm:250px md:300px lg:400px xl:500px xxl:600px",
                    src: "/img/new/connect_wallet.png",
                    alt: "Connect wallet to earn prize on Defi Pool Finance",
                    title: "Connect wallet",
                    loading: "lazy",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "buttons-area" }, [
              _c(
                "button",
                { staticClass: "btn cyan", attrs: { type: "button" } },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("common.connect_wallet")) +
                      "\n          "
                  ),
                ]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "desc" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("docs.starter_pack_long_desc")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "h5" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("docs.starter_pack_sure_to")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "list-area" }, [
            _c("div", { staticClass: "list" }, [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "icon-area check" },
                  [_c("CheckFilled")],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "text-area" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.$t("docs.starter_pack_sure_to1")) +
                      "\n            "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "icon-area check" },
                  [_c("CheckFilled")],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "text-area" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.$t("docs.starter_pack_sure_to2")) +
                      "\n            "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "icon-area check" },
                  [_c("CheckFilled")],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "text-area" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.$t("docs.starter_pack_sure_to3")) +
                      "\n            "
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "list" }, [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "icon-area cross" },
                  [_c("CrossFilled")],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "text-area" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.$t("docs.starter_pack_sure_to4")) +
                      "\n            "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "icon-area cross" },
                  [_c("CrossFilled")],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "text-area" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.$t("docs.starter_pack_sure_to5")) +
                      "\n            "
                  ),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c("div", { staticClass: "h2" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("docs.defipool_supports")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "wallets-area" }, [
            _c(
              "a",
              {
                ref: "nofollow noreferrer noopener",
                staticClass: "wallet",
                attrs: { href: "https://metamask.io/", target: "_blank" },
              },
              [
                _c("div", { staticClass: "image-area metamask" }, [
                  _c(
                    "picture",
                    [
                      _c("source", {
                        attrs: {
                          srcset: "/img/new/metamask.webp",
                          type: "image/webp",
                        },
                      }),
                      _vm._v(" "),
                      _c("nuxt-img", {
                        attrs: {
                          fit: "inside",
                          width: "275",
                          sizes:
                            "sm:175px md:200px lg:225px xl:250px xxl:275px",
                          src: "/img/new/metamask.png",
                          alt: "Metamask wallet connect on Defi Pool Finance",
                          title: "Metamask",
                          loading: "lazy",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "h5" }, [
                  _vm._v("\n            Metamask\n          "),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                ref: "nofollow noreferrer noopener",
                staticClass: "wallet",
                attrs: { href: "https://www.coinbase.com/", target: "_blank" },
              },
              [
                _c("div", { staticClass: "image-area coinbase" }, [
                  _c(
                    "picture",
                    [
                      _c("source", {
                        attrs: {
                          srcset: "/img/new/coinbase.webp",
                          type: "image/webp",
                        },
                      }),
                      _vm._v(" "),
                      _c("nuxt-img", {
                        attrs: {
                          fit: "inside",
                          width: "275",
                          sizes:
                            "sm:175px md:200px lg:225px xl:250px xxl:275px",
                          src: "/img/new/coinbase.png",
                          alt: "Coinbase wallet connect on Defi Pool Finance",
                          title: "Coinbase",
                          loading: "lazy",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "h5" }, [
                  _vm._v("\n            Coinbase\n          "),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                ref: "nofollow noreferrer noopener",
                staticClass: "wallet",
                attrs: { href: "https://walletconnect.com/", target: "_blank" },
              },
              [
                _c("div", { staticClass: "image-area walletconnect" }, [
                  _c(
                    "picture",
                    [
                      _c("source", {
                        attrs: {
                          srcset: "/img/new/walletconnect.webp",
                          type: "image/webp",
                        },
                      }),
                      _vm._v(" "),
                      _c("nuxt-img", {
                        attrs: {
                          fit: "inside",
                          width: "275",
                          sizes:
                            "sm:175px md:200px lg:225px xl:250px xxl:275px",
                          src: "/img/new/walletconnect.png",
                          alt: "Wallet Connect on Defi Pool Finance",
                          title: "Wallet Connect",
                          loading: "lazy",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "h5" }, [
                  _vm._v("\n            Wallet Connect\n          "),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                ref: "nofollow noreferrer noopener",
                staticClass: "wallet",
                attrs: { href: "https://fortmatic.com/", target: "_blank" },
              },
              [
                _c("div", { staticClass: "image-area formatic" }, [
                  _c(
                    "picture",
                    [
                      _c("source", {
                        attrs: {
                          srcset: "/img/new/formatic.webp",
                          type: "image/webp",
                        },
                      }),
                      _vm._v(" "),
                      _c("nuxt-img", {
                        attrs: {
                          fit: "inside",
                          width: "275",
                          sizes:
                            "sm:175px md:200px lg:225px xl:250px xxl:275px",
                          src: "/img/new/formatic.png",
                          alt: "Fortmatic wallet connect on Defi Pool Finance",
                          title: "Fortmatic",
                          loading: "lazy",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "h5" }, [
                  _vm._v("\n            Fortmatic\n          "),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                ref: "nofollow noreferrer noopener",
                staticClass: "wallet",
                attrs: { href: "https://www.portis.io/", target: "_blank" },
              },
              [
                _c("div", { staticClass: "image-area portis" }, [
                  _c(
                    "picture",
                    [
                      _c("source", {
                        attrs: {
                          srcset: "/img/new/portis.webp",
                          type: "image/webp",
                        },
                      }),
                      _vm._v(" "),
                      _c("nuxt-img", {
                        attrs: {
                          fit: "inside",
                          width: "182",
                          sizes: "sm:80px md:100px lg:120px xl:140px xxl:180px",
                          src: "/img/new/portis.png",
                          alt: "Portis wallet connect on Defi Pool Finance",
                          title: "Portis wallet",
                          loading: "lazy",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "h5" }, [
                  _vm._v("\n            Portis wallet\n          "),
                ]),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c("div", { staticClass: "section" }, [
            _c("div", { staticClass: "image-area" }, [
              _c(
                "picture",
                [
                  _c("source", {
                    attrs: { srcset: "/img/new/bnbs.webp", type: "image/webp" },
                  }),
                  _vm._v(" "),
                  _c("nuxt-img", {
                    attrs: {
                      fit: "inside",
                      width: "803",
                      sizes: "sm:300px md:400px lg:500px xl:550px xxl:500px",
                      src: "/img/new/bnbs.png",
                      alt: "Deposit BEP20 on Defi Pool Finance",
                      title: "BEP20 Defi Pool Finance",
                      loading: "lazy",
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "text-area" }, [
              _c("div", { staticClass: "h2" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("docs.deposit_bep20")) +
                    "\n          "
                ),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "desc" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("docs.deposit_bep20_desc")) +
                    "\n          "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "items" }, [
                _c("div", { staticClass: "item" }, [
                  _c("div", { staticClass: "h6" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("docs.binance_bridge")) +
                        "\n              "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "desc" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("docs.binance_bridge_desc")) +
                        "\n              "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      ref: "nofollow noreferrer noopener",
                      staticClass: "wallet",
                      attrs: {
                        href: "https://docs.binance.org/",
                        target: "_blank",
                      },
                    },
                    [
                      _vm._v(
                        "\n                docs.binance.org\n              "
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "item" }, [
                  _c("div", { staticClass: "h6" }, [
                    _vm._v("\n                Binance.com\n              "),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "desc" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("docs.binance_desc")) +
                        "\n              "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      ref: "nofollow noreferrer noopener",
                      staticClass: "wallet",
                      attrs: { href: "https://binance.com/", target: "_blank" },
                    },
                    [_vm._v("\n                binance.com\n              ")]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "item" }, [
                  _c("div", { staticClass: "h6" }, [
                    _vm._v("\n                Pointpay.com\n              "),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "desc" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("docs.pointpay_desc")) +
                        "\n              "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      ref: "nofollow noreferrer noopener",
                      staticClass: "wallet",
                      attrs: { href: "https://pointpay.io/", target: "_blank" },
                    },
                    [_vm._v("\n                upcoming\n              ")]
                  ),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c("div", { staticClass: "h2" }, [
            _vm._v(
              "\n        " + _vm._s(_vm.$t("docs.connect_wallet")) + "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "desc" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("docs.connect_wallet_desc")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "h5" }, [
            _vm._v(
              "\n        " + _vm._s(_vm.$t("docs.correct_network")) + "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "items" }, [
            _c(
              "div",
              {
                staticClass: "item",
                attrs: { tooltip: _vm.$t("common.copy") },
                on: {
                  click: function ($event) {
                    return _vm.copyText($event, "BNB Smart Chain")
                  },
                },
              },
              [
                _c("p", { staticClass: "name" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("docs.network_name")) +
                      "\n          "
                  ),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "value" }, [
                  _vm._v("\n            BNB Smart Chain\n          "),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "item",
                attrs: { tooltip: _vm.$t("common.copy") },
                on: {
                  click: function ($event) {
                    return _vm.copyText(
                      $event,
                      "https://bsc-dataseed.binance.org/"
                    )
                  },
                },
              },
              [
                _c("p", { staticClass: "name" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("docs.rpc_url")) +
                      "\n          "
                  ),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "value" }, [
                  _vm._v("\n            bsc-dataseed.binance.org\n          "),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "item",
                attrs: { tooltip: _vm.$t("common.copy") },
                on: {
                  click: function ($event) {
                    return _vm.copyText($event, "BNB")
                  },
                },
              },
              [
                _c("p", { staticClass: "name" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("docs.symbol")) +
                      "\n          "
                  ),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "value" }, [
                  _vm._v("\n            BNB\n          "),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "item",
                attrs: { tooltip: _vm.$t("common.copy") },
                on: {
                  click: function ($event) {
                    return _vm.copyText($event, "https://bscscan.com/")
                  },
                },
              },
              [
                _c("p", { staticClass: "name" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("docs.explorer_url")) +
                      "\n          "
                  ),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "value" }, [
                  _vm._v("\n            bscscan.com\n          "),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "item",
                attrs: { tooltip: _vm.$t("common.copy") },
                on: {
                  click: function ($event) {
                    return _vm.copyText($event, "56")
                  },
                },
              },
              [
                _c("p", { staticClass: "name" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("docs.chain_id")) +
                      "\n          "
                  ),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "value" }, [
                  _vm._v("\n            56\n          "),
                ]),
              ]
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "oracles",
          class: { content: true, active: _vm.currentPage === "oracles" },
        },
        [
          _c("section", { staticClass: "section" }, [
            _c("div", { staticClass: "image-area smaller" }, [
              _c(
                "picture",
                [
                  _c("source", {
                    attrs: {
                      srcset: "/img/new/oracle.webp",
                      type: "image/webp",
                    },
                  }),
                  _vm._v(" "),
                  _c("nuxt-img", {
                    attrs: {
                      fit: "inside",
                      width: "524",
                      sizes: "sm:300px md:400px lg:500px xl:550px xxl:500px",
                      src: "/img/new/oracle.png",
                      alt: "Oracles on Defi Pool Finance",
                      title: "Oracle Defi Pool Finance",
                      loading: "lazy",
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "text-area" }, [
              _c("div", { staticClass: "h2" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("docs.oracles")) +
                    "\n          "
                ),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "desc" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("docs.oracles_long_desc")) +
                    "\n          "
                ),
              ]),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "contracts",
          class: { content: true, active: _vm.currentPage === "contracts" },
        },
        [
          _c("section", { staticClass: "section" }, [
            _c("div", { staticClass: "text-area" }, [
              _c("div", { staticClass: "h2" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("docs.contracts_links")) +
                    "\n          "
                ),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "desc" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("docs.contracts_links_desc")) +
                    "\n          "
                ),
              ]),
              _vm._v(" "),
              _c("ul", [
                _c("li", [
                  _c(
                    "a",
                    {
                      ref: "nofollow noopener noreferrer",
                      attrs: {
                        href: "https://bscscan.com/address/0xc896d43fe5432fb4660c2a7da420c5d47609cb26",
                        target: "_blank",
                      },
                    },
                    [
                      _vm._v(
                        "\n                $FLOATIE " +
                          _vm._s(_vm.$t("docs.token")) +
                          "\n              "
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "a",
                    {
                      ref: "nofollow noopener noreferrer",
                      attrs: {
                        href: "https://bscscan.com/address/0x4caa2ddcf4818e1f3778d9fbb5aaf72136d03966",
                        target: "_blank",
                      },
                    },
                    [
                      _vm._v(
                        "\n                $SPLASHIE " +
                          _vm._s(_vm.$t("docs.token")) +
                          "\n              "
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "a",
                    {
                      ref: "nofollow noopener noreferrer",
                      attrs: {
                        href: "https://bscscan.com/address/0xefa0283673b2150a8eeb86d0927ec17511358423",
                        target: "_blank",
                      },
                    },
                    [_vm._v("\n                MasterChef\n              ")]
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "a",
                    {
                      ref: "nofollow noopener noreferrer",
                      attrs: {
                        href: "https://bscscan.com/address/0x4aae80fd995f6e983709907ed5d7a413000d5c25",
                        target: "_blank",
                      },
                    },
                    [
                      _vm._v(
                        "\n                $FLOATIE " +
                          _vm._s(_vm.$t("docs.factory")) +
                          "\n              "
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "a",
                    {
                      ref: "nofollow noopener noreferrer",
                      attrs: {
                        href: "https://bscscan.com/address/0x79c614ce01ca2cd38b66c43b6c1988a875f6bb29",
                        target: "_blank",
                      },
                    },
                    [
                      _vm._v(
                        "\n                $FLOATIE " +
                          _vm._s(_vm.$t("docs.router")) +
                          "\n              "
                      ),
                    ]
                  ),
                ]),
              ]),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "features",
          class: { content: true, active: _vm.currentPage === "features" },
        },
        [
          _c("div", { staticClass: "h2" }, [
            _vm._v("\n        " + _vm._s(_vm.$t("docs.swap")) + "\n      "),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "desc" }, [
            _vm._v(
              "\n        " + _vm._s(_vm.$t("docs.swap_long_desc")) + "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "items" }, [
            _c("div", { staticClass: "item no-pointer" }, [
              _c("div", { staticClass: "h4" }, [
                _vm._v("\n            0.17%\n          "),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "desc" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("docs.swap_return")) +
                    "\n          "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "item no-pointer" }, [
              _c("div", { staticClass: "h4" }, [
                _vm._v("\n            0.02%\n          "),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "desc" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("docs.sent_treasury")) +
                    "\n          "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "item no-pointer" }, [
              _c("div", { staticClass: "h4" }, [
                _vm._v("\n            0.01%\n          "),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "desc" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("docs.sent_burn")) +
                    "\n          "
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c("section", { staticClass: "section" }, [
            _c("div", { staticClass: "text-area" }, [
              _c("div", { staticClass: "h2" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("docs.liquidity")) +
                    "\n          "
                ),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "desc" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("docs.liquidity_desc1")) +
                    "\n          "
                ),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "desc" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("docs.liquidity_desc2")) +
                    "\n          "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "image-area reverse" }, [
              _c(
                "picture",
                [
                  _c("source", {
                    attrs: {
                      srcset: "/img/new/chart_up.webp",
                      type: "image/webp",
                    },
                  }),
                  _vm._v(" "),
                  _c("nuxt-img", {
                    attrs: {
                      fit: "inside",
                      width: "874",
                      sizes: "sm:300px md:400px lg:500px xl:550px xxl:500px",
                      src: "/img/new/chart_up.png",
                      alt: "Earn and profit on Defi Pool Finance",
                      title: "Earn with Defi Pool Finance",
                      loading: "lazy",
                    },
                  }),
                ],
                1
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "h5" }, [
            _vm._v(
              "\n        " + _vm._s(_vm.$t("docs.for_example")) + "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "items list" }, [
            _c("div", { staticClass: "item no-pointer" }, [
              _c("div", { staticClass: "h6" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("docs.example1")) +
                    "\n          "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "item no-pointer" }, [
              _c("div", { staticClass: "h6" }, [
                _vm._v(
                  "\n            1 LP " +
                    _vm._s(_vm.$t("docs.example_token")) +
                    " = 1 $FLOATIE + 1 BNB\n          "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "item no-pointer" }, [
              _c("div", { staticClass: "h6" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("docs.example3")) +
                    "\n          "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "item no-pointer" }, [
              _c("div", { staticClass: "h6" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("docs.example4")) +
                    "\n          "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "item no-pointer" }, [
              _c("div", { staticClass: "h6" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("docs.example5")) +
                    "\n          "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "item no-pointer" }, [
              _c("div", { staticClass: "h6" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("docs.example6")) +
                    "\n          "
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "desc" }, [
            _vm._v(
              "\n        " + _vm._s(_vm.$t("docs.example_desc")) + "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("section", { staticClass: "section" }, [
            _c("div", { staticClass: "image-area smaller" }, [
              _c(
                "picture",
                [
                  _c("source", {
                    attrs: {
                      srcset: "/img/new/filling_wallet.webp",
                      type: "image/webp",
                    },
                  }),
                  _vm._v(" "),
                  _c("nuxt-img", {
                    attrs: {
                      fit: "inside",
                      width: "845",
                      sizes: "sm:300px md:400px lg:500px xl:550px xxl:500px",
                      src: "/img/new/filling_wallet.png",
                      alt: "Fill and top up wallet on Defi Pool Finance",
                      title: "Fill cypto wallet on Defi Pool Finance",
                      loading: "lazy",
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "text-area" }, [
              _c("div", { staticClass: "h2" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("docs.loss")) +
                    "\n          "
                ),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "desc" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("docs.loss_desc")) +
                    "\n            "
                ),
                _c(
                  "a",
                  {
                    attrs: {
                      href: "https://academy.binance.com/en/articles/impermanent-loss-explained",
                      target: "_blank",
                      rel: "nofollow noopener noreferrer",
                    },
                  },
                  [_vm._v("Binance Academy")]
                ),
                _vm._v(".\n          "),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c("section", { staticClass: "section" }, [
            _c("div", { staticClass: "text-area" }, [
              _c("div", { staticClass: "h2" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("docs.adding_liquidity")) +
                    "\n          "
                ),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "desc" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("docs.adding_liquidity_desc")) +
                    "\n          "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "image-area smaller reverse" }, [
              _c(
                "picture",
                [
                  _c("source", {
                    attrs: {
                      srcset: "/img/new/swapping_floatie.webp",
                      type: "image/webp",
                    },
                  }),
                  _vm._v(" "),
                  _c("nuxt-img", {
                    attrs: {
                      fit: "inside",
                      width: "624",
                      sizes: "sm:300px md:400px lg:500px xl:550px xxl:500px",
                      src: "/img/new/swapping_floatie.png",
                      alt: "Swap BNB and stake on Defi Pool Finance",
                      title: "Swap BNB and stake on Defi Pool Finance",
                      loading: "lazy",
                    },
                  }),
                ],
                1
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("section", { staticClass: "section boxed" }, [
            _c("div", { staticClass: "image-area" }, [
              _c(
                "picture",
                [
                  _c("source", {
                    attrs: {
                      srcset: "/img/new/placing_chart.webp",
                      type: "image/webp",
                    },
                  }),
                  _vm._v(" "),
                  _c("nuxt-img", {
                    attrs: {
                      fit: "inside",
                      width: "770",
                      sizes: "sm:300px md:400px lg:500px xl:550px xxl:500px",
                      src: "/img/new/placing_chart.png",
                      alt: "Earn crypto and yeild farm on Defi Pool Finance",
                      title: "Earn crypto and yeild farme on Defi Pool Finance",
                      loading: "lazy",
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "text-area" }, [
              _c("div", { staticClass: "h2" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("docs.farming")) +
                    "\n          "
                ),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "desc" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("docs.farming_desc")) +
                    "\n          "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "h5" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("docs.farming_include")) +
                    "\n          "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "list-area" }, [
                _c("div", { staticClass: "list" }, [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "icon-area check" },
                      [_c("CheckFilled")],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "text-area" }, [
                      _vm._v(
                        "\n                  " +
                          _vm._s(_vm.$t("docs.farming_include_desc1")) +
                          "\n                "
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "list" }, [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "icon-area check" },
                      [_c("CheckFilled")],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "text-area" }, [
                      _vm._v(
                        "\n                  " +
                          _vm._s(_vm.$t("docs.farming_include_desc2")) +
                          "\n                "
                      ),
                    ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "desc" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("docs.farming_desc2")) +
                    "\n          "
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("section", { staticClass: "section" }, [
            _c("div", { staticClass: "text-area" }, [
              _c("div", { staticClass: "h2" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("docs.stake")) +
                    "\n          "
                ),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "desc" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("docs.stake_long_desc")) +
                    "\n          "
                ),
              ]),
              _vm._v(" "),
              _c("ul", [
                _c("li", { staticClass: "normal" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.$t("docs.stake_long_desc_p1")) +
                      "\n            "
                  ),
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "normal" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.$t("docs.stake_long_desc_p2")) +
                      "\n            "
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "image-area smaller reverse" }, [
              _c(
                "picture",
                [
                  _c("source", {
                    attrs: {
                      srcset: "/img/new/floaties_coins.webp",
                      type: "image/webp",
                    },
                  }),
                  _vm._v(" "),
                  _c("nuxt-img", {
                    attrs: {
                      fit: "inside",
                      width: "922",
                      sizes: "sm:300px md:400px lg:500px xl:550px xxl:500px",
                      src: "/img/new/floaties_coins.png",
                      alt: "Crypto tokens earning on Defi Pool Finance",
                      title: "Crypto tokens earning on Defi Pool Finance",
                      loading: "lazy",
                    },
                  }),
                ],
                1
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c("div", { staticClass: "h5" }, [
            _vm._v(
              "\n        " + _vm._s(_vm.$t("docs.looks_like")) + "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "cycle" }, [
            _vm.darkTheme
              ? _c(
                  "picture",
                  [
                    _c("source", {
                      attrs: {
                        srcset: "/img/new/stake_dark.webp",
                        type: "image/webp",
                      },
                    }),
                    _vm._v(" "),
                    _c("nuxt-img", {
                      attrs: {
                        fit: "inside",
                        width: "770",
                        sizes:
                          "sm:500px md:900px lg:1250px xl:1500px xxl:1700px",
                        src: "/img/new/stake_dark.png",
                        alt: "Stake and earn crypto on Defi Pool Finance",
                        title:
                          "Stake and earn crypto farme on Defi Pool Finance",
                        loading: "lazy",
                      },
                    }),
                  ],
                  1
                )
              : _c(
                  "picture",
                  [
                    _c("source", {
                      attrs: {
                        srcset: "/img/new/stake_light.webp",
                        type: "image/webp",
                      },
                    }),
                    _vm._v(" "),
                    _c("nuxt-img", {
                      attrs: {
                        fit: "inside",
                        width: "770",
                        sizes:
                          "sm:500px md:900px lg:1250px xl:1500px xxl:1700px",
                        src: "/img/new/stake_light.png",
                        alt: "Stake and earn crypto on Defi Pool Finance",
                        title:
                          "Stake and earn crypto farme on Defi Pool Finance",
                        loading: "lazy",
                      },
                    }),
                  ],
                  1
                ),
          ]),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c("div", { staticClass: "h2" }, [
            _vm._v(
              "\n        " + _vm._s(_vm.$t("docs.long_term_stake")) + "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "desc" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("docs.long_term_stake_desc1")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "desc" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("docs.long_term_stake_desc2")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "desc" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("docs.long_term_stake_desc3")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "desc" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("docs.long_term_stake_desc4")) +
                "\n      "
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "roadmap",
          class: { content: true, active: _vm.currentPage === "roadmap" },
        },
        [
          _c("div", { staticClass: "h2" }, [
            _vm._v("\n        " + _vm._s(_vm.$t("docs.roadmap")) + "\n      "),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "desc" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("docs.roadmap_long_desc")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "roadmap-container" }, [
            _vm.darkTheme
              ? _c(
                  "picture",
                  [
                    _c("source", {
                      attrs: {
                        srcset: "/img/new/roadmap_dark.webp",
                        type: "image/webp",
                      },
                    }),
                    _vm._v(" "),
                    _c("nuxt-img", {
                      attrs: {
                        fit: "inside",
                        width: "770",
                        sizes:
                          "sm:700px md:1200px lg:1500px xl:1750px xxl:2000px",
                        src: "/img/new/roadmap_dark.png",
                        alt: "Roadmap on how Defi Pool Finance is improving and become the most modern DEX service",
                        title: "Roadmap Defi Pool Finance ",
                        loading: "lazy",
                      },
                    }),
                  ],
                  1
                )
              : _c(
                  "picture",
                  [
                    _c("source", {
                      attrs: {
                        srcset: "/img/new/roadmap_light.webp",
                        type: "image/webp",
                      },
                    }),
                    _vm._v(" "),
                    _c("nuxt-img", {
                      attrs: {
                        fit: "inside",
                        width: "770",
                        sizes:
                          "sm:500px md:900px lg:1250px xl:1500px xxl:1700px",
                        src: "/img/new/roadmap_light.png",
                        alt: "Roadmap on how Defi Pool Finance is improving and become the most modern DEX service",
                        title: "Roadmap Defi Pool Finance",
                        loading: "lazy",
                      },
                    }),
                  ],
                  1
                ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "roadmap-flow" }, [
            _c("div", { staticClass: "flow-section" }, [
              _c("div", { staticClass: "header" }, [
                _c("div", { staticClass: "icon" }, [_c("ChevronDown")], 1),
                _vm._v(" "),
                _c("div", { staticClass: "text" }, [
                  _c("div", { staticClass: "h4" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("docs.ongoing")) +
                        "\n              "
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "flow-content" }, [
                _c("div", { staticClass: "subheader" }, [
                  _vm._v("\n              2023 Q1\n            "),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "list" }, [
                  _c("div", { staticClass: "item" }, [
                    _c("div", { staticClass: "icon" }, [_c("CheckFilled")], 1),
                    _vm._v(" "),
                    _c("p", { staticClass: "desc" }, [
                      _vm._v(
                        "\n                  " +
                          _vm._s(_vm.$t("docs.governance")) +
                          "\n                "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "item" }, [
                    _c("div", { staticClass: "icon" }, [_c("CheckFilled")], 1),
                    _vm._v(" "),
                    _c("p", { staticClass: "desc" }, [
                      _vm._v(
                        "\n                  " +
                          _vm._s(_vm.$t("docs.reward_farms")) +
                          "\n                "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "item" }, [
                    _c("div", { staticClass: "icon" }, [_c("CheckFilled")], 1),
                    _vm._v(" "),
                    _c("p", { staticClass: "desc" }, [
                      _vm._v(
                        "\n                  " +
                          _vm._s(_vm.$t("docs.performance")) +
                          "\n                "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "item" }, [
                    _c(
                      "div",
                      { staticClass: "icon disabled" },
                      [_c("CheckFilled")],
                      1
                    ),
                    _vm._v(" "),
                    _c("p", { staticClass: "desc" }, [
                      _vm._v(
                        "\n                  " +
                          _vm._s(_vm.$t("docs.site_listings")) +
                          "\n                "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "item" }, [
                    _c(
                      "div",
                      { staticClass: "icon disabled" },
                      [_c("CheckFilled")],
                      1
                    ),
                    _vm._v(" "),
                    _c("p", { staticClass: "desc" }, [
                      _vm._v(
                        "\n                  " +
                          _vm._s(_vm.$t("docs.lottery")) +
                          "\n                "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "item" }, [
                    _c(
                      "div",
                      { staticClass: "icon disabled" },
                      [_c("CheckFilled")],
                      1
                    ),
                    _vm._v(" "),
                    _c("p", { staticClass: "desc" }, [
                      _vm._v(
                        "\n                  " +
                          _vm._s(_vm.$t("docs.farm_adjustments")) +
                          "\n                "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "item" }, [
                    _c(
                      "div",
                      { staticClass: "icon disabled" },
                      [_c("CheckFilled")],
                      1
                    ),
                    _vm._v(" "),
                    _c("p", { staticClass: "desc" }, [
                      _vm._v(
                        "\n                  " +
                          _vm._s(_vm.$t("docs.ido_preparation")) +
                          "\n                "
                      ),
                    ]),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "flow-section upcoming" }, [
              _c("div", { staticClass: "header" }, [
                _c("div", { staticClass: "icon" }, [_c("ChevronDown")], 1),
                _vm._v(" "),
                _c("div", { staticClass: "text" }, [
                  _c("div", { staticClass: "h4" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("docs.upcoming")) +
                        "\n              "
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "flow-content" }, [
                _c("div", { staticClass: "label" }, [
                  _vm._v(
                    "\n              + " +
                      _vm._s(_vm.$t("docs.active_pr")) +
                      "\n            "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "subheader" }, [
                  _vm._v("\n              2023 Q2\n            "),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "list" }, [
                  _c("div", { staticClass: "item" }, [
                    _c(
                      "div",
                      { staticClass: "icon disabled" },
                      [_c("CheckFilled")],
                      1
                    ),
                    _vm._v(" "),
                    _c("p", { staticClass: "desc" }, [
                      _vm._v(
                        "\n                  " +
                          _vm._s(_vm.$t("docs.limit_order")) +
                          "\n                "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "item" }, [
                    _c(
                      "div",
                      { staticClass: "icon disabled" },
                      [_c("CheckFilled")],
                      1
                    ),
                    _vm._v(" "),
                    _c("p", { staticClass: "desc" }, [
                      _vm._v(
                        "\n                  " +
                          _vm._s(_vm.$t("docs.zap_liquidity")) +
                          "\n                "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "item" }, [
                    _c(
                      "div",
                      { staticClass: "icon disabled" },
                      [_c("CheckFilled")],
                      1
                    ),
                    _vm._v(" "),
                    _c("p", { staticClass: "desc" }, [
                      _vm._v(
                        "\n                  " +
                          _vm._s(_vm.$t("docs.prediction_game")) +
                          "\n                "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "item" }, [
                    _c(
                      "div",
                      { staticClass: "icon disabled" },
                      [_c("CheckFilled")],
                      1
                    ),
                    _vm._v(" "),
                    _c("p", { staticClass: "desc" }, [
                      _vm._v(
                        "\n                  " +
                          _vm._s(_vm.$t("docs.lending")) +
                          "\n                "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "item" }, [
                    _c(
                      "div",
                      { staticClass: "icon disabled" },
                      [_c("CheckFilled")],
                      1
                    ),
                    _vm._v(" "),
                    _c("p", { staticClass: "desc" }, [
                      _vm._v(
                        "\n                  " +
                          _vm._s(_vm.$t("docs.polygon")) +
                          "\n                "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "item" }, [
                    _c(
                      "div",
                      { staticClass: "icon disabled" },
                      [_c("CheckFilled")],
                      1
                    ),
                    _vm._v(" "),
                    _c("p", { staticClass: "desc" }, [
                      _vm._v(
                        "\n                  " +
                          _vm._s(_vm.$t("docs.partnerships")) +
                          "\n                "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "item" }, [
                    _c(
                      "div",
                      { staticClass: "icon disabled" },
                      [_c("CheckFilled")],
                      1
                    ),
                    _vm._v(" "),
                    _c("p", { staticClass: "desc" }, [
                      _vm._v(
                        "\n                  " +
                          _vm._s(_vm.$t("docs.ratings")) +
                          "\n                "
                      ),
                    ]),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "flow-section exploring" }, [
              _c("div", { staticClass: "header" }, [
                _c("div", { staticClass: "icon" }, [_c("ChevronDown")], 1),
                _vm._v(" "),
                _c("div", { staticClass: "text" }, [
                  _c("div", { staticClass: "h4" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("docs.exploring")) +
                        "\n              "
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "flow-content" }, [
                _c("div", { staticClass: "subheader" }, [
                  _vm._v("\n              2023 Q2-Q3\n            "),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "list" }, [
                  _c("div", { staticClass: "item" }, [
                    _c(
                      "div",
                      { staticClass: "icon disabled" },
                      [_c("CheckFilled")],
                      1
                    ),
                    _vm._v(" "),
                    _c("p", { staticClass: "desc" }, [
                      _vm._v(
                        "\n                  " +
                          _vm._s(_vm.$t("docs.cex_listing")) +
                          "\n                "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "item" }, [
                    _c(
                      "div",
                      { staticClass: "icon disabled" },
                      [_c("CheckFilled")],
                      1
                    ),
                    _vm._v(" "),
                    _c("p", { staticClass: "desc" }, [
                      _vm._v(
                        "\n                  " +
                          _vm._s(_vm.$t("docs.expert_trading")) +
                          "\n                "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "item" }, [
                    _c(
                      "div",
                      { staticClass: "icon disabled" },
                      [_c("CheckFilled")],
                      1
                    ),
                    _vm._v(" "),
                    _c("p", { staticClass: "desc" }, [
                      _vm._v(
                        "\n                  " +
                          _vm._s(_vm.$t("docs.lifebuoy")) +
                          "\n                "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "item" }, [
                    _c(
                      "div",
                      { staticClass: "icon disabled" },
                      [_c("CheckFilled")],
                      1
                    ),
                    _vm._v(" "),
                    _c("p", { staticClass: "desc" }, [
                      _vm._v(
                        "\n                  " +
                          _vm._s(_vm.$t("docs.assets_pool")) +
                          "\n                "
                      ),
                    ]),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "tokenomics",
          class: { content: true, active: _vm.currentPage === "tokenomics" },
        },
        [
          _c("div", { staticClass: "h2" }, [
            _vm._v(
              "\n        " + _vm._s(_vm.$t("docs.tokenomics")) + "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "h5" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("docs.tokenomics_based")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "items list" }, [
            _c("div", { staticClass: "item" }, [
              _c("div", { staticClass: "h4" }, [
                _vm._v("\n            1\n          "),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "h6" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("docs.tokenomics_based_desc1")) +
                    "\n          "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "item" }, [
              _c("div", { staticClass: "h4" }, [
                _vm._v("\n            2\n          "),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "h6" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("docs.tokenomics_based_desc2")) +
                    "\n          "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "item" }, [
              _c("div", { staticClass: "h4" }, [
                _vm._v("\n            3\n          "),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "h6" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("docs.tokenomics_based_desc3")) +
                    "\n          "
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "desc" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("docs.tokenomics_long_desc")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "h5" }, [
            _vm._v("\n        I. FLOATIE - $FLE\n      "),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "desc" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("docs.tokenomics_fle_desc")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "h4" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("docs.tokenomics_fle_utility")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("ul", { staticClass: "list" }, [
            _c("li", { staticClass: "item" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("docs.tokenomics_fle_exchange")) +
                  "\n        "
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "item" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("docs.tokenomics_fle_stake")) +
                  "\n        "
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "item" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("docs.tokenomics_fle_payment")) +
                  "\n        "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "desc" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("docs.tokenomics_fle_created")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "h6" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("docs.tokenomics_fle_supply")) +
                ":\n      "
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "desc" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("docs.tokenomics_fle_supply_desc")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "h6" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("docs.tokenomics_fle_model")) +
                ":\n      "
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "desc" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("docs.tokenomics_fle_model_desc")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "h6" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("docs.tokenomics_fle_core")) +
                ":\n      "
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "desc" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("docs.tokenomics_fle_core_desc")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "h6" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("docs.tokenomics_fle_schedule")) +
                ":\n      "
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "desc" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("docs.tokenomics_fle_schedule_desc")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "h6" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("docs.tokenomics_fle_burn")) +
                ":\n      "
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "desc" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("docs.tokenomics_fle_burn_desc")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "h4" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("docs.tokenomics_fle_info")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("ul", { staticClass: "list" }, [
            _c("li", { staticClass: "item" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("docs.tokenomics_fle_name")) +
                  ": FLOATIE\n        "
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "item" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("docs.tokenomics_fle_symbol")) +
                  ": $FLE\n        "
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "item" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("docs.tokenomics_fle_total")) +
                  ": 500,000,000\n        "
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "item" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("docs.tokenomics_fle_hardcap")) +
                  ": 3,080,000 USD\n        "
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "item" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("docs.tokenomics_fle_softcap")) +
                  ": 500,000USD\n        "
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "item" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("docs.tokenomics_fle_chain")) +
                  ": Binance Smart Chain (BSC)\n        "
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "item" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("docs.tokenomics_fle_info_model")) +
                  ": " +
                  _vm._s(_vm.$t("docs.tokenomics_fle_info_model_value")) +
                  "\n        "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "h4" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("docs.tokenomics_fle_allocation")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "chart-container" },
            [
              _c("DoughnutChart", {
                attrs: {
                  "chart-data": _vm.allocation.data,
                  options: _vm.allocation.options,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "h6" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("docs.tokenomics_fle_use")) +
                ":\n      "
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "desc" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("docs.tokenomics_fle_following")) +
                ":\n      "
            ),
          ]),
          _vm._v(" "),
          _c("ul", { staticClass: "list" }, [
            _c("li", { staticClass: "item" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("docs.tokenomics_fle_repenish")) +
                  "\n        "
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "item" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("docs.tokenomics_fle_handle")) +
                  "\n        "
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "item" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("docs.tokenomics_fle_community")) +
                  "\n        "
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "item" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("docs.tokenomics_fle_dao")) +
                  "\n        "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "h5" }, [
            _vm._v(
              "\n        II. " +
                _vm._s(_vm.$t("docs.tokenomics_phe")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "desc" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("docs.tokenomics_phe_desc1")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "desc" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("docs.tokenomics_phe_desc2")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "desc" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("docs.tokenomics_phe_desc3")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "h4" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("docs.tokenomics_phe_utilities")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("ul", { staticClass: "list" }, [
            _c("li", { staticClass: "item" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("docs.tokenomics_phe_rewards")) +
                  "\n        "
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "item" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("docs.tokenomics_phe_assets")) +
                  "\n        "
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "item" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("docs.tokenomics_phe_vote")) +
                  "\n        "
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "item" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("docs.tokenomics_phe_propose")) +
                  "\n        "
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "item" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("docs.tokenomics_phe_staking")) +
                  "\n        "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "h4" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("docs.tokenomics_fle_staking")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "desc" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("docs.tokenomics_fle_host")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "desc" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("docs.tokenomics_fle_allocate")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "desc" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("docs.tokenomics_fle_program")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "desc" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("docs.tokenomics_fle_systems")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "h6" }, [
            _vm._v(
              "\n        1. " +
                _vm._s(_vm.$t("docs.tokenomics_fle_flexible")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "desc" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("docs.tokenomics_fle_flexible_desc")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "h6" }, [
            _vm._v(
              "\n        2. " +
                _vm._s(_vm.$t("docs.tokenomics_fle_fixed")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "desc" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("docs.tokenomics_fle_fixed_desc1")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "desc italic" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("docs.tokenomics_fle_fixed_desc2")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "desc" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("docs.tokenomics_fle_fixed_based")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("ul", { staticClass: "list" }, [
            _c("li", { staticClass: "item" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("docs.tokenomics_fle_fixed_based_desc1")) +
                  "\n        "
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "item" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("docs.tokenomics_fle_fixed_based_desc2")) +
                  "\n        "
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "item" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("docs.tokenomics_fle_fixed_based_desc3")) +
                  "\n        "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "tabs" }, [
            _c("div", { staticClass: "tabs-line" }, [
              _c(
                "div",
                {
                  class: { tab: true, active: _vm.tokenomicsTab === "3m" },
                  on: {
                    click: function ($event) {
                      return _vm.changeTokenomicsTab("3m")
                    },
                  },
                },
                [
                  _vm._v(
                    "\n            3 " +
                      _vm._s(_vm.$t("common.months")) +
                      "\n          "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  class: { tab: true, active: _vm.tokenomicsTab === "5m" },
                  on: {
                    click: function ($event) {
                      return _vm.changeTokenomicsTab("5m")
                    },
                  },
                },
                [
                  _vm._v(
                    "\n            5 " +
                      _vm._s(_vm.$t("common.months")) +
                      "\n          "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  class: { tab: true, active: _vm.tokenomicsTab === "8m" },
                  on: {
                    click: function ($event) {
                      return _vm.changeTokenomicsTab("8m")
                    },
                  },
                },
                [
                  _vm._v(
                    "\n            8 " +
                      _vm._s(_vm.$t("common.months")) +
                      "\n          "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  class: { tab: true, active: _vm.tokenomicsTab === "12m" },
                  on: {
                    click: function ($event) {
                      return _vm.changeTokenomicsTab("12m")
                    },
                  },
                },
                [
                  _vm._v(
                    "\n            12 " +
                      _vm._s(_vm.$t("common.months")) +
                      "\n          "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  class: { tab: true, active: _vm.tokenomicsTab === "24m" },
                  on: {
                    click: function ($event) {
                      return _vm.changeTokenomicsTab("24m")
                    },
                  },
                },
                [
                  _vm._v(
                    "\n            24 " +
                      _vm._s(_vm.$t("common.months")) +
                      "\n          "
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _vm.tokenomicsTab === "3m"
              ? _c("div", { staticClass: "content-area" }, [
                  _c("p", { staticClass: "desc" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("docs.tokenomics_higher_apy")) +
                        "\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "desc" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.$t("docs.tokenomics_receive_airdrop", {
                            float: "1/5",
                          })
                        ) +
                        "\n          "
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.tokenomicsTab === "5m"
              ? _c("div", { staticClass: "content-area" }, [
                  _c("p", { staticClass: "desc" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("docs.tokenomics_higher_apy")) +
                        "\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "desc" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.$t("docs.tokenomics_receive_airdrop", {
                            float: "2/5",
                          })
                        ) +
                        "\n          "
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.tokenomicsTab === "8m"
              ? _c("div", { staticClass: "content-area" }, [
                  _c("p", { staticClass: "desc" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("docs.tokenomics_higher_apy")) +
                        "\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "desc" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.$t("docs.tokenomics_receive_airdrop", {
                            float: "3/5",
                          })
                        ) +
                        "\n          "
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.tokenomicsTab === "12m"
              ? _c("div", { staticClass: "content-area" }, [
                  _c("p", { staticClass: "desc" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("docs.tokenomics_higher_apy")) +
                        "\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "desc" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.$t("docs.tokenomics_receive_airdrop", {
                            float: "4/5",
                          })
                        ) +
                        "\n          "
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.tokenomicsTab === "24m"
              ? _c("div", { staticClass: "content-area" }, [
                  _c("p", { staticClass: "desc" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("docs.tokenomics_higher_apy")) +
                        "\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "desc" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("docs.tokenomics_receive_full_airdrop")) +
                        "\n          "
                    ),
                  ]),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "h4" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("docs.tokenomics_case_study")) +
                ":\n      "
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "desc" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("docs.tokenomics_translates")) +
                ":\n      "
            ),
          ]),
          _vm._v(" "),
          _c("ul", { staticClass: "list" }, [
            _c("li", { staticClass: "item" }, [
              _vm._v(
                "\n          40.5 $FLE " +
                  _vm._s(_vm.$t("docs.tokenomics_daily")) +
                  "\n        "
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "item" }, [
              _vm._v(
                "\n          293 $FLE " +
                  _vm._s(_vm.$t("docs.tokenomics_weekly")) +
                  "\n        "
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "item" }, [
              _vm._v(
                "\n          1,220 $FLE " +
                  _vm._s(_vm.$t("docs.tokenomics_monthly")) +
                  "\n        "
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "item" }, [
              _vm._v(
                "\n          14,650 $FLE " +
                  _vm._s(_vm.$t("docs.tokenomics_yearly")) +
                  "\n        "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "desc" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("docs.tokenomics_rewards_come")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "desc italic" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("docs.tokenomics_rewards_come_ps")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "h4" }, [
            _vm._v(
              "\n        " + _vm._s(_vm.$t("docs.tokenomics_swap")) + "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "desc italic" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("docs.tokenomics_swap_desc")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "h4" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("docs.tokenomics_swap_case")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("ul", { staticClass: "list" }, [
            _c("li", { staticClass: "item" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("docs.tokenomics_swap1")) +
                  "\n          "
              ),
              _c("ul", { staticClass: "list" }, [
                _c("li", { staticClass: "item" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.$t("docs.tokenomics_swap2")) +
                      "\n            "
                  ),
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "item" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.$t("docs.tokenomics_swap3")) +
                      "\n            "
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "item" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("docs.tokenomics_swap4")) +
                  "\n        "
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "item" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("docs.tokenomics_swap5")) +
                  "\n        "
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "item" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("docs.tokenomics_swap6")) +
                  "\n        "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "h4" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("docs.tokenomics_swap_schedule")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "desc" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("docs.tokenomics_swap_schedule_desc1")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "desc" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("docs.tokenomics_swap_schedule_desc2")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "desc italic" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("docs.tokenomics_swap_schedule_desc3")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "h4" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("docs.tokenomics_burning")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "desc" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("docs.tokenomics_burning_desc")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "h6" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("docs.tokenomics_burning_buyback")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "desc" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("docs.tokenomics_burning_buyback_desc")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "h6" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("docs.tokenomics_burning_allocation")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("ul", { staticClass: "list" }, [
            _c("li", { staticClass: "item" }, [
              _vm._v(
                "\n          50% - " +
                  _vm._s(_vm.$t("docs.tokenomics_burn_address")) +
                  "\n        "
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "item" }, [
              _vm._v(
                "\n          50% - " +
                  _vm._s(_vm.$t("docs.tokenomics_strength")) +
                  "\n        "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "h4" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("docs.tokenomics_distribution")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "h6" }, [
            _vm._v(
              "\n        " + _vm._s(_vm.$t("docs.tokenomics_dex")) + "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "desc" }, [
            _vm._v(
              "\n        1% " +
                _vm._s(_vm.$t("docs.tokenomics_buy_tax")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("ul", { staticClass: "list" }, [
            _c("li", { staticClass: "item" }, [
              _vm._v(
                "\n          50% " +
                  _vm._s(_vm.$t("docs.tokenomics_buyback")) +
                  "\n        "
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "item" }, [
              _vm._v(
                "\n          30% " +
                  _vm._s(_vm.$t("docs.tokenomics_rewards_pool")) +
                  "\n        "
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "item" }, [
              _vm._v(
                "\n          20% " +
                  _vm._s(_vm.$t("docs.tokenomics_team_wallet")) +
                  "\n        "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "desc" }, [
            _vm._v(
              "\n        3% " +
                _vm._s(_vm.$t("docs.tokenomics_sell_tax")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("ul", { staticClass: "list" }, [
            _c("li", { staticClass: "item" }, [
              _vm._v(
                "\n          50% " +
                  _vm._s(_vm.$t("docs.tokenomics_buyback")) +
                  "\n        "
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "item" }, [
              _vm._v(
                "\n          30% " +
                  _vm._s(_vm.$t("docs.tokenomics_rewards_pool")) +
                  "\n        "
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "item" }, [
              _vm._v(
                "\n          20% " +
                  _vm._s(_vm.$t("docs.tokenomics_team_wallet")) +
                  "\n        "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "h6" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("docs.tokenomics_token_swap")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("ul", { staticClass: "list" }, [
            _c("li", { staticClass: "item" }, [
              _vm._v(
                "\n          0.17% " +
                  _vm._s(_vm.$t("docs.tokenomics_returns")) +
                  "\n        "
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "item" }, [
              _vm._v(
                "\n          0.02% " +
                  _vm._s(_vm.$t("docs.tokenomics_sent_treasury")) +
                  "\n        "
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "item" }, [
              _vm._v(
                "\n          0.01% " +
                  _vm._s(_vm.$t("docs.tokenomics_buyback_burn")) +
                  "\n        "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "h6" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("docs.tokenomics_straight_swap")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "desc" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("docs.tokenomics_outside_schedule")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("ul", { staticClass: "list" }, [
            _c("li", { staticClass: "item" }, [
              _vm._v(
                "\n          50% " +
                  _vm._s(_vm.$t("docs.tokenomics_fle_treasury")) +
                  "\n        "
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "item" }, [
              _vm._v(
                "\n          40% " +
                  _vm._s(_vm.$t("docs.tokenomics_rewards_pool")) +
                  "\n        "
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "item" }, [
              _vm._v(
                "\n          10% " +
                  _vm._s(_vm.$t("docs.tokenomics_burn_address")) +
                  "\n        "
              ),
            ]),
          ]),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("section", { staticClass: "banner" }, [
      _c("div", { staticClass: "content-area" }, [
        _c("div", { staticClass: "image-area" }, [
          _c(
            "picture",
            [
              _c("source", {
                attrs: {
                  srcset: "/img/new/floating_man.webp",
                  type: "image/webp",
                },
              }),
              _vm._v(" "),
              _c("nuxt-img", {
                attrs: {
                  fit: "inside",
                  width: "867",
                  sizes: "sm:300px md:350px lg:450px xl:500px xxl:550px",
                  src: "/img/new/floating_man.png",
                  alt: "Pool rules Defi Pool Finance",
                  title: "Pool rules",
                  loading: "lazy",
                },
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "text-area" }, [
          _vm.darkTheme
            ? _c(
                "picture",
                [
                  _c("source", {
                    attrs: {
                      srcset: "/img/new/docs_help.webp",
                      type: "image/webp",
                    },
                  }),
                  _vm._v(" "),
                  _c("nuxt-img", {
                    attrs: {
                      fit: "inside",
                      width: "867",
                      sizes: "sm:300px md:350px lg:450px xl:500px xxl:550px",
                      src: "/img/new/docs_help.png",
                      alt:
                        _vm.$t("docs.navigate_header") + " Defi Pool Finance",
                      title: _vm.$t("docs.navigate_header"),
                      loading: "lazy",
                    },
                  }),
                ],
                1
              )
            : _c(
                "picture",
                [
                  _c("source", {
                    attrs: {
                      srcset: "/img/new/docs_help_light.webp",
                      type: "image/webp",
                    },
                  }),
                  _vm._v(" "),
                  _c("nuxt-img", {
                    attrs: {
                      fit: "inside",
                      width: "867",
                      sizes: "sm:300px md:350px lg:450px xl:500px xxl:550px",
                      src: "/img/new/docs_help_light.png",
                      alt:
                        _vm.$t("docs.navigate_header") + " Defi Pool Finance",
                      title: _vm.$t("docs.navigate_header"),
                      loading: "lazy",
                    },
                  }),
                ],
                1
              ),
          _vm._v(" "),
          _c("p", { staticClass: "desc" }, [
            _vm._v(
              "\n          " + _vm._s(_vm.$t("docs.navigate")) + "\n        "
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }